import React from 'react';
import { siteContent } from '../content/siteContent';
import ServiceCard from './ServiceCard';
import './Services.css';

const Services = () => {
  const { services } = siteContent;

  return (
    <section id="services" className="services" aria-labelledby="services-heading">
      <div className="container">
        <div className="services-intro">
          <h2 id="services-heading">{services.heading}</h2>
          <p className="services-message">{services.message}</p>
        </div>
        <div className="services-grid card-grid">
          {services.items.map((service) => (
            <ServiceCard
              key={service.title}
              title={service.title}
              description={service.description}
              icon={service.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
